/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("WorkSingleIntroSection", ["jquery", "Behaviors"], factory);
    } else {
        root.WorkSingleIntroSection = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function WorkSingleIntroSection() {
        Behaviors.init(WorkSingleIntroSection, this, arguments);
            
        var $animation_elements = $('.WorkSingleIntroSection-content_item .fl-animated.fl-fade-up');
        // var $animation_elements = $('.WorkSingleIntroSection-content_item .fl-animated.fl-fade-up.fl-photo-content');
        var $window = $(window);
        var already_done = false;
        if ( $animation_elements.length > 0 ) {
            $window.on('scroll load resize', check_if_in_view);
            function check_if_in_view() {
                var window_height = $window.height();
                var window_top_position = $window.scrollTop();
                var window_bottom_position = (window_top_position + window_height);


                // var $element = $animation_elements;
                // var element_height = $element.outerHeight();
                // var element_top_position = $element.offset().top;
                // var element_bottom_position = (element_top_position + element_height);

                //check to see if this current container is within viewport
                $.each($animation_elements, function(index) {
                    var $element = $(this);
                    var element_height = $element.outerHeight();
                    var element_top_position = $element.offset().top;
                    var element_bottom_position = (element_top_position + element_height);
                    if ((element_bottom_position >= window_top_position) &&
                        (element_top_position <= window_bottom_position)) {
                        $element.addClass('fl-animated');
                    } else {
                        $element.removeClass('fl-animated');
                    }
                    already_done = true;
                });

                
            }
            // already_done = true;
        }
        
    }

    Behaviors.inherit(WorkSingleIntroSection, Behaviors.Behavior);

    WorkSingleIntroSection.QUERY = "[data-WorkSingleIntroSection]";

    WorkSingleIntroSection.ELEMENTS = {
        loadMoreButton: ".WorkSingleIntroSection-content_tabs_items_item_loadMore__button",
        tabItemNav: ".WorkSingleIntroSection-content_tabs_nav a",
        tabContentSection: ".WorkSingleIntroSection-content_tabs_items_item",
    };
    
    Behaviors.register_behavior(WorkSingleIntroSection);
    
    module.WorkSingleIntroSection = WorkSingleIntroSection;
    
    return module;
}));
